export default __webpack_public_path__ + "static/media/sheep-black.590f8a48.jpeg";